import { PlayerConfig } from "@/components/organisms/VideoPlayer/VideoPlayer.interface";
import { VideoShare } from "@/components/pages/VideoShare";
import { useApi } from "@/api";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { OrderService } from "@/types";

const VideoShareView = () => {

    const { shareId } = useParams<'shareId'>();

    const { order: orderEntity } = useApi();

    const [playerConfig, setPlayerConfig] = useState<PlayerConfig>();

    const getSharedVideo = async (value: string) => {
        await orderEntity.getSharedVideo(value);
    }

    const getPlayerConfig = (sharedVideo: OrderService) => { 
        const videoInfo = JSON.parse(sharedVideo.label || '{}') as PlayerConfig; 
    
        const videoSrc = sharedVideo.uploadFiles.length > 0 
                  ? sharedVideo.uploadFiles[0].fullURL
                  : sharedVideo.externalLink;
    
        return { autoPlay: false,
                clientLogoSize: videoInfo.clientLogoSize || 10,
                clientLogoSrc: videoInfo.clientLogoSrc,
                description: videoInfo.description,
                loop: false,
                primaryColor: videoInfo.primaryColor || '#ffffff',
                providerLogoSrc: videoInfo.providerLogoSrc,
                title: videoInfo.title,
                videoName: videoInfo.title,
                videoSrc: videoSrc }
    }

    useEffect(() => {
        if (shareId) {
            getSharedVideo(shareId);
        }
    }, [shareId]);

    useEffect(() => {
        if (orderEntity.sharedVideo) {
            setPlayerConfig(getPlayerConfig(orderEntity.sharedVideo));
        }
    }, [orderEntity.sharedVideo]);

    return (
        <>
        { playerConfig && <VideoShare playerConfig={playerConfig}></VideoShare> }
        </>
    );
}

export default VideoShareView;